export const PATH = {
  home: "/",
  poles: "/pali-rotoinfissi",
  consultancy: "/consulenza",
  about: "/chi-siamo",
  contacts: "/contatti",
  privacy: "/privacy-policy",
  cookie: "/cookie-policy",
  terms: "/termini-condizioni",
  notFound: "/404",
  unknown: "*",
} as const;

export const SECTIONS_ID = {
  app: "app-id",
  home: {
    services: "our-services",
  },
  contacts: {
    map: "contacts-map",
  },
};
